export const CHANGE_ACCOUNT_DRAWER_VISIBILITY = 'CHANGE_ACCOUNT_DRAWER_VISIBILITY';